import React from 'react';
import {
  standardDateTime,
  MetadataElementIdConstants,
  datePassed,
  standardDate
} from '@ibinder/common-utils';
import getMarketName from '../../../../../../utils/getMarketData';
export const orgColumns = [
  {
    Header: 'Name',
    accessor: 'name'
  },
  {
    Header: 'ID',
    accessor: 'id'
  },
  {
    Header: 'created',
    accessor: 'created',
    Cell: ({ cell, ...other }) => {
      return cell.value ? standardDate(cell.value) : '';
    }
  },
  {
    Header: 'Market ID',
    accessor: 'market.id'
  },
  {
    Header: 'Market',
    accessor: 'market.name'
  }
];

export const binderColumns = [
  {
    Header: 'Name',
    accessor: 'binder.name'
  },
  {
    Header: 'Description',
    accessor: 'binder.binderBackDescription'
  },
  {
    Header: 'ID',
    accessor: 'binder.id'
    // Cell: ({cell})=>(<div style={{maxWidth: 2rem}}></div>)
  },
  {
    Header: 'Type',
    accessor: 'binder.type'
  },
  {
    Header: 'Created date',
    accessor: 'binder.createdDate',
    Cell: ({ cell }) => standardDateTime(cell.value)
  },
  {
    Header: 'Binder state',
    accessor: 'binder.state',
    id: 'binderState'
  },
  {
    Header: 'Organization',
    accessor: 'organizationId'
  },
  {
    Header: 'Value',
    accessor: 'binder.metadata',
    Cell: ({ cell }) => {
      const cellValue = Array.isArray(cell.value) ? cell.value : [];
      const TheValue = cellValue.find(
        (m) =>
          m.metadataElementId === MetadataElementIdConstants.GLOBAL_ProjectSize
      )?.value;

      return TheValue ?? '<NOT SET>';
    }
  }
];

export const userColumns = [
  {
    Header: 'Name',
    accessor: 'fullName'
  },
  {
    Header: 'Company',
    accessor: 'company.name'
  },
  {
    Header: 'Email',
    accessor: 'email'
  },
  {
    Header: 'Phone',
    accessor: 'phone'
  },
  {
    Header: 'id',
    accessor: 'id'
  }
];

export const tenderColumns = [
  {
    Header: 'Name',
    accessor: 'name'
  },
  {
    Header: 'Description',
    accessor: 'tenderProfile.shortDescription'
  },
  {
    Header: 'ID',
    accessor: 'id'
    // Cell: ({cell})=>(<div style={{maxWidth: 2rem}}></div>)
  },
  {
    Header: 'Created date',
    accessor: 'inserted',
    Cell: ({ cell }) => standardDateTime(cell.value)
  },
  {
    Header: 'Tender state',
    accessor: 'endDate',
    Cell: ({ cell }) => {
      return datePassed(cell.value) ? 'Ended' : 'Active';
    }
  },
  {
    Header: 'Organization',
    id: 'organizationId',
    accessor: 'organizationId'
  },
  {
    Header: 'Market',
    id: 'Market',
    accessor: 'organizationId',
    Cell: ({ cell }) => getMarketName(cell.value)
  }
];
